module.exports = __webpack_public_path__ + "assets/id_drag.95b4c3db.svg";